import React from "react";
import typographyTokens from "../../styles/tokens/typography";
import { BodyProps } from "../../types/Typography";

export const Body: React.FC<BodyProps> = ({
  size = "lg",
  element = "p",
  align = "left",
  color,
  truncate = false,
  lineClamp,
  children,
  className = "",
  style = {},
  onClick,
  testID,
  ...rest
}) => {
  const getStyles = (): React.CSSProperties => {
    let tokenSet;
    switch (size) {
      case "xl":
        tokenSet = typographyTokens.bodyXl;
        break;
      case "lg":
        tokenSet = typographyTokens.bodyLg;
        break;
      case "md":
        tokenSet = typographyTokens.bodyMd;
        break;
      case "sm":
        tokenSet = typographyTokens.bodySm;
        break;
    }

    const fontWeightValue = parseInt(tokenSet.fontWeight);

    const baseStyles: React.CSSProperties = {
      fontFamily: tokenSet.fontFamily,
      fontSize: `${tokenSet.fontSize}px`,
      lineHeight: `${tokenSet.lineHeight}px`,
      fontWeight: fontWeightValue,
      color: color || tokenSet.color,
      textAlign: align,
      letterSpacing: tokenSet.letterSpacing,
      textDecoration: tokenSet.textDecoration || "none",
    };

    if (truncate) {
      baseStyles.whiteSpace = "nowrap";
      baseStyles.overflow = "hidden";
      baseStyles.textOverflow = "ellipsis";
      baseStyles.display = "block";
    }

    if (lineClamp && lineClamp > 0) {
      baseStyles.display = "-webkit-box";
      baseStyles.WebkitLineClamp = lineClamp;
      baseStyles.WebkitBoxOrient = "vertical";
      baseStyles.overflow = "hidden";
      baseStyles.textOverflow = "ellipsis";
    }

    return baseStyles;
  };

  const combinedStyles = {
    ...getStyles(),
    ...style,
  };

  const linkProps = element === "a" ? rest : {};

  const Component = element as React.ElementType;

  return (
    <Component
      style={combinedStyles}
      className={className}
      data-testid={testID}
      onClick={onClick}
      {...linkProps}
    >
      {children}
    </Component>
  );
};
